import axios from 'axios';
import { BASE_URL } from '../../config';

export async function getPostalCodes(cityId: string = '') {
  let {
    data: { data },
  } = await axios.get(`${BASE_URL}/postal-codes?cityId=${cityId}`);
  data = data.map((x: any) => ({ value: x._id, label: x._id }));
  return data;
}

export async function getSubCities(
  postalCode: string = '',
  cityId: string = ''
) {
  // console.log("api getSubCities, postalCode: ", postalCode);

  let url = `${BASE_URL}/sub-cities`;

  if (postalCode) {
    url += `?postalCode=${postalCode}`;
  } else if (cityId) {
    url += `?cityId=${cityId}`;
  }

  let {
    data: { data },
  } = await axios.get(url);
  data = data.map((x: any) => ({ value: x._id, label: x.name }));
  return data;
}

export async function getCities(subCityId: string = '', stateId: string = '') {
  let url = `${BASE_URL}/cities`;

  if (subCityId) {
    url += `?subCityId=${subCityId}`;
  } else if (stateId) {
    url += `?stateId=${stateId}`;
  }

  let {
    data: { data },
  } = await axios.get(url);
  data = data.map((x: any) => ({ value: x._id, label: x.name }));
  return data;
}

export async function getStates(cityId: string = '') {
  let url = `${BASE_URL}/states`;

  if (cityId) {
    url += `?cityId=${cityId}`;
  }

  let {
    data: { data },
  } = await axios.get(url);

  data = data.map((x: any) => ({ value: x._id, label: x.name }));
  return data;
}

export async function getPrefixes() {
  let {
    data: { data },
  } = await axios.get(`${BASE_URL}/prefixes`);

  data = data.map((x: any) => ({ value: x._id, label: x.name }));

  return data;
}

export async function getSexes() {
  let {
    data: { data },
  } = await axios.get(`${BASE_URL}/sexes`);

  data = data.map((x: any) => ({ value: x._id, label: x.name }));

  return data;
}

export async function getBirthYears() {
  const data = [];

  const now = new Date();

  const year = now.getFullYear();

  for (let i = year; i >= year - 99; i--) {
    data.push({ value: i, label: i });
  }

  return data;
}

export async function getBanks() {
  let {
    data: { data },
  } = await axios.get(`${BASE_URL}/banks`);

  data = data.map((x: any) => ({ value: x._id, label: x.name }));

  return data;
}

export async function getShop() {
  let { data } = await axios.get(`${BASE_URL}/shops/get-shop`);

  return data;
}

export async function getShipments() {
  let {
    data: { data },
  } = await axios.get(`${BASE_URL}/shipments`);

  return data;
}

export async function getShipment(shipmentId: string) {
  let { data } = await axios.get(`${BASE_URL}/shipments/${shipmentId}`);

  return data;
}

export async function getShops(
  { lat, long }: any = {
    lat: 0,
    long: 0,
  },
  isFilterMyShop = false,
  skip: number = 1,
  limit: number = 10,
  user: string
) {
  const url = `${BASE_URL}/shops?lat=${lat}&long=${long}&skip=${skip}&limit=${limit}&user=${
    user ? user : ''
  }`;
  const result = await axios.get(url);

  return result.data.shops;
}

export async function getCategoriesOnlyLv1() {
  let {
    data: { data },
  } = await axios.get(`/categorys/get-only-lv1`);

  return data;
}

export async function getShopsByProductCategoryId({
  categoryId,
  currentLocation = { lat: 0, long: 0 },
  isFilterMyShop = false,
}: any) {
  let { data } = await axios.get(
    `/shops/get-shops-by-product-category-id/${categoryId}?isFilterMyShop=${isFilterMyShop}`
  );
  return data;
}

export async function returnRedeemCode(orderId: string) {
  await axios.patch(`/promotions/returnRedeemCode`, { orderId });
}
